<template>
  <v-autocomplete
    :items="items"
    v-model="selectedDepartment"
    :label="customLabel"
    item-text="name"
    item-value="name"
    :outlined="outlinedInputs"
    @change="onChange($event)"
    :clearable="clearable"
    :hide-details="hideDetails"
    :dense="dense"
  ></v-autocomplete>
</template>

<script>
import { ALL_DEPARTMENTS_BASIC_LIST } from "../../../constants/graphql";
export default {
  name: "DepartmentListSelect",

  props: {
    departmentName: {
      type: String,
      default: () => "",
    },
    customLabel: {
      type: String,
      default: "Department",
    },
    value: {
      type: String,
      default: () => "",
    },
    clearable: {
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    showAll: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      selectedDepartment:
        this.value && this.value != "" ? this.value : this.departmentName,
      items: [],
      departments: {},
    };
  },

  watch: {
    departmentName: function (val) {
      this.selectedDepartment = val;
    },
    value(newVal) {
      this.selectedDepartment = newVal;
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    onChange(data) {
      this.$emit("onSelect", this.selectedDepartment);
      this.$emit("input", this.selectedDepartment);
    },
  },

  apollo: {
    departments: {
      query: ALL_DEPARTMENTS_BASIC_LIST,
      variables() {
        return {};
      },
      result({ data }) {
        const deps = data.departments.edges.map((node) => node.node.name);
        this.items = this.showAll ? ["All", ...deps] : deps;
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/DepartmentListSelect.vue